var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFooterWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,29.9c0.5-2,1-3.9,1.6-5.9c0.1-0.5,0.3-1,0.5-1.6c0-0.1,0-0.3-0.1-0.5c-1.4-2.5-2.1-5.3-1.9-8.1 C0.6,9.1,2.9,5.2,6.9,2.5c2.7-1.8,5.7-2.7,8.9-2.4C21.6,0.6,26,3.4,28.4,8.7c2.4,5.2,1.8,10.3-1.5,14.9c-2.4,3.3-5.7,5.3-9.8,5.9 c-3.1,0.5-6.2-0.1-9-1.5c-0.1-0.1-0.3-0.1-0.5-0.1c-2.4,0.7-4.8,1.2-7.2,1.9C0.4,29.9,0.3,29.9,0.1,29.9z M3.6,26.4 c0.1,0,0.1,0,0.2-0.1c1.4-0.3,2.7-0.7,4-1c0.3-0.1,0.5-0.1,0.8,0.1c2.9,1.8,6,2.2,9.4,1.4c6.2-1.6,10.2-7.7,9.2-14 c-1.1-6.3-7-11.1-14-10.1C10.3,3.2,7.9,4.4,6,6.5c-2.5,2.8-3.6,6.1-3.2,9.8c0.2,1.9,0.8,3.6,2,5.3c0.1,0.2,0.1,0.4,0.1,0.6 c-0.1,0.5-0.3,0.9-0.4,1.4C4.2,24.5,4,25.5,3.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,11.5c0-1.2,0.5-2.3,1.4-3.1C9.1,8.2,9.4,8,9.8,8c0.2,0,0.4,0,0.7,0c0.4-0.1,0.7,0.1,0.8,0.5 c0.4,1,0.8,2,1.2,3c0.1,0.2,0,0.5-0.1,0.6c-0.3,0.5-0.6,0.8-0.9,1.2c-0.2,0.3-0.3,0.5-0.1,0.8c1.2,2,2.9,3.5,5.1,4.4 c0.3,0.1,0.6,0.1,0.8-0.2c0.4-0.5,0.7-0.9,1.1-1.4c0.3-0.3,0.4-0.4,0.8-0.3c1,0.5,2.1,1,3.1,1.5c0.1,0.1,0.3,0.3,0.3,0.5 c0,1.6-0.5,2.3-2.2,3.1c-1,0.4-2,0.3-2.9,0c-3.6-1-6.2-3.3-8.3-6.2c-0.7-0.9-1.2-1.9-1.5-3C7.5,12.3,7.5,11.9,7.5,11.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooterWhatsapp);
export default __webpack_public_path__ + "static/media/icon-footer-whatsapp.86fd32c98a5f0b3c6f2f8a64fa2e293e.svg";
export { ForwardRef as ReactComponent };